export const GradeThreeEnglishGradeSubjectId = 10;
export const GradeThreeMathGradeSubjectId = 3;
export const GradeThreeUrduGradeSubjectId = 53;
export const GradeThreeNumeracyGradeSubjectId = 70;
export const GradeThreeLiteracyEnglishGradeSubjectId = 58;
export const SupportedGradeSubjects = [
  GradeThreeNumeracyGradeSubjectId,
  GradeThreeLiteracyEnglishGradeSubjectId,
];
export const HasUsedExamChecker = 'hasUsedExamChecker';
export const hasInviteParentPrompt = 'hasInviteParentPrompt';

const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

export const getMaxCountForModel = (modelData: any): number => {
  if (!modelData) return 0;

  const createdCount = modelData['created']?.['count'] ?? 0;
  const updatedCount = modelData['updated']?.['count'] ?? 0;

  return Math.max(createdCount, updatedCount);
};

export const getModelCount = (
  models: ReadonlyArray<string>,
  data: any,
): number[] => {
  return models.map((model): number => {
    const modelData = data[model];
    return getMaxCountForModel(modelData);
  });
};

export const convertBytes = (bytes: number | undefined) => {
  let index = 0;
  if (bytes) {
    while (bytes >= 1024 && index < sizes.length - 1) {
      bytes /= 1024;
      index++;
    }
    return `${bytes.toFixed(2)} ${sizes[index]}`;
  } else return 'N/A';
};

/**
 * Formats a date string from ISO format to DD-MM-YYYY.
 *
 * @param {string} dateString - The date string in ISO format (e.g., 2024-09-19T07:41:17.178739Z).
 * @returns {string} - The formatted date string in DD-MM-YYYY format.
 *
 * @example
 * const formattedDate = formatDate('2024-09-19T07:41:17.178739Z');
 * console.log(formattedDate); // Output: 19-09-2024
 */
export const formatDate = (
  dateString: string,
  separator: string = '-',
): string => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return [day, month, year].join(separator);
};

export const hasFeatureFlagsChanged = (
  updatedFlags: { [key: string]: any },
  initialFlags: { [key: string]: any },
): boolean => {
  for (const key in updatedFlags) {
    const updatedValue = updatedFlags[key];
    const initialValue = initialFlags[key];

    if (updatedValue) {
      const valuesAreDifferent =
        typeof updatedValue === 'object' || Array.isArray(updatedValue)
          ? JSON.stringify(updatedValue) !== JSON.stringify(initialValue)
          : updatedValue !== initialValue;

      if (valuesAreDifferent) {
        return true;
      }
    }

    if (!(key in initialFlags) && updatedValue) {
      return true;
    }
  }
  return false;
};
